import api, { ApiResponse } from './api';

export interface Receta {
  id: number;
  token: string | null;
  pacienteId: number | null;
  nombrePaciente: string | null;
  fechaNacimiento: string | null;
  peso: number | null;
  talla: number | null;
  percentilePeso: string | null;
  percentileTalla: string | null;
  edadTexto: string | null;
  medicamentos: string | null;
  formato: string | null;
  fecha: string;
}

export interface CreateRecetaData {
  pacienteId?: number;
  nombrePaciente?: string;
  fechaNacimiento?: string;
  peso?: number;
  talla?: number;
  percentilePeso?: string;
  percentileTalla?: string;
  edadTexto?: string;
  medicamentos?: string;
  formato?: string;
  guardarPaciente?: boolean;
  apellido1?: string;
  apellido2?: string;
  nombre?: string;
  sexo?: string;
  procedencia?: string;
}

class RecetasService {
  async create(data: CreateRecetaData): Promise<Receta> {
    const res = await api.post<ApiResponse<Receta>>('recetas', data);
    return res.data.data;
  }

  async findAll(params?: { skip?: number; take?: number; pacienteId?: number }): Promise<{ data: Receta[]; total: number }> {
    const query: Record<string, string> = {};
    if (params?.skip != null) query.skip = String(params.skip);
    if (params?.take != null) query.take = String(params.take);
    if (params?.pacienteId != null) query.pacienteId = String(params.pacienteId);
    const res = await api.get<ApiResponse<{ data: Receta[]; total: number }>>('recetas', { params: query });
    return res.data.data;
  }

  async findByPaciente(pacienteId: number): Promise<Receta[]> {
    const res = await api.get<ApiResponse<Receta[]>>(`recetas/paciente/${pacienteId}`);
    return res.data.data;
  }

  async findOne(id: number): Promise<Receta> {
    const res = await api.get<ApiResponse<Receta>>(`recetas/${id}`);
    return res.data.data;
  }

  async update(id: number, data: Partial<CreateRecetaData>): Promise<Receta> {
    const res = await api.patch<ApiResponse<Receta>>(`recetas/${id}`, data);
    return res.data.data;
  }

  async remove(id: number): Promise<void> {
    await api.delete(`recetas/${id}`);
  }
}

export const recetasService = new RecetasService();
